import { render, staticRenderFns } from "./message-menu.vue?vue&type=template&id=2b7d3796"
import script from "./message-menu.vue?vue&type=script&lang=js"
export * from "./message-menu.vue?vue&type=script&lang=js"
import style0 from "./message-menu.vue?vue&type=style&index=0&id=2b7d3796&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconMessageLightGrey: require('/app/components/icons/IconMessageLightGrey.vue').default,IconMessage: require('/app/components/icons/IconMessage.vue').default,VSpacer: require('/app/node_modules/vuetify/lib/components/VGrid/VSpacer.js').default,VIcon: require('/app/node_modules/vuetify/lib/components/VIcon/VIcon.js').default,VBtn: require('/app/node_modules/vuetify/lib/components/VBtn/VBtn.js').default,VCard: require('/app/node_modules/vuetify/lib/components/VCard/VCard.js').default,VMenu: require('/app/node_modules/vuetify/lib/components/VMenu/VMenu.js').default})


/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardSubtitle,VCardText,VCardTitle,VIcon,VMenu,VSpacer})
